import type { CanvasObject } from '../types';

export interface AABB { x: number; y: number; width: number; height: number }

/**
 * 기본 AABB 계산 (회전 고려 안 함)
 */
export function computeAABB(objects: CanvasObject[]): AABB | null {
  if (!objects.length) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const o of objects) {
    const x1 = o.x;
    const y1 = o.y;
    const x2 = o.x + o.width;
    const y2 = o.y + o.height;
    if (x1 < minX) minX = x1;
    if (y1 < minY) minY = y1;
    if (x2 > maxX) maxX = x2;
    if (y2 > maxY) maxY = y2;
  }
  return { x: Math.round(minX), y: Math.round(minY), width: Math.round(maxX - minX), height: Math.round(maxY - minY) };
}

/**
 * 회전을 고려한 실제 바운딩 박스 계산 (다중 선택용)
 */
export function computeRotatedAABB(objects: CanvasObject[]): AABB | null {
  if (!objects.length) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  
  for (const o of objects) {
    const angle = o.rotation || 0;
    const hasRotation = Math.abs(angle) > 1e-6;
    
    if (!hasRotation) {
      // 회전이 없으면 단순 AABB
      const x1 = o.x;
      const y1 = o.y;
      const x2 = o.x + o.width;
      const y2 = o.y + o.height;
      if (x1 < minX) minX = x1;
      if (y1 < minY) minY = y1;
      if (x2 > maxX) maxX = x2;
      if (y2 > maxY) maxY = y2;
    } else {
      // 회전이 있으면 4개 코너를 회전 변환
      const cx = o.x + o.width / 2;
      const cy = o.y + o.height / 2;
      const cos = Math.cos(angle);
      const sin = Math.sin(angle);
      
      // 객체의 4개 코너 (로컬 좌표계)
      const corners = [
        { x: o.x, y: o.y },
        { x: o.x + o.width, y: o.y },
        { x: o.x + o.width, y: o.y + o.height },
        { x: o.x, y: o.y + o.height }
      ];
      
      // 각 코너를 회전 변환
      const rotatedCorners = corners.map(p => {
        const dx = p.x - cx;
        const dy = p.y - cy;
        return {
          x: cx + dx * cos - dy * sin,
          y: cy + dx * sin + dy * cos
        };
      });
      
      // 회전된 코너들의 최소/최대값 계산
      for (const corner of rotatedCorners) {
        if (corner.x < minX) minX = corner.x;
        if (corner.y < minY) minY = corner.y;
        if (corner.x > maxX) maxX = corner.x;
        if (corner.y > maxY) maxY = corner.y;
      }
    }
  }
  
  return { x: Math.round(minX), y: Math.round(minY), width: Math.round(maxX - minX), height: Math.round(maxY - minY) };
}


